import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VMenu,
    {
      attrs: { "offset-y": "", "close-on-content-click": false },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "a",
                _vm._g(
                  _vm._b(
                    {
                      staticStyle: { color: "blue" },
                      on: { click: _vm.loadInventory },
                    },
                    "a",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(" " + _vm._s(_vm.unitCount) + " ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VList,
        [
          _c(
            VSheet,
            { attrs: { "max-height": "600px", "min-width": "500px" } },
            [
              _c(
                VSimpleTable,
                { staticClass: "table pa-5" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        [
                          _vm.mode !== "view"
                            ? _c(VCheckbox, {
                                attrs: {
                                  "hide-details": "",
                                  dense: "",
                                  value: true,
                                },
                                on: { click: _vm.toggleAll },
                                model: {
                                  value: _vm.selectedAll,
                                  callback: function ($$v) {
                                    _vm.selectedAll = $$v
                                  },
                                  expression: "selectedAll",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.inventory.status")
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.inventory.code"))
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.inventory.weight")
                          )
                        ),
                      ]),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.inventory.unit"))
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._l(_vm.units, function (unit, index) {
                    return _c("tr", { key: unit.id }, [
                      _c(
                        "td",
                        [
                          _vm.mode == "view"
                            ? _c("span", [_vm._v(_vm._s(index + 1) + ".")])
                            : _c(VCheckbox, {
                                staticClass: "ml-1",
                                attrs: {
                                  disabled: unit.status !== "Available",
                                  "hide-details": "",
                                  dense: "",
                                  value: true,
                                },
                                on: { click: _vm.updateSelected },
                                model: {
                                  value: unit.selected,
                                  callback: function ($$v) {
                                    _vm.$set(unit, "selected", $$v)
                                  },
                                  expression: "unit.selected",
                                },
                              }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          unit.description
                            ? _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      color: "primary",
                                                      text: "",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.translateStatus(
                                                        unit.status
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v(_vm._s(unit.description))])]
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.translateStatus(unit.status))
                                ),
                              ]),
                        ],
                        1
                      ),
                      _c("td", [_vm._v(" " + _vm._s(unit.code) + " ")]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("formatNumber")(unit.amountPerUnit)) +
                            _vm._s(unit.unitMeasure)
                        ),
                      ]),
                      _c("td", [_vm._v(" " + _vm._s(unit.unitShare) + " ")]),
                    ])
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }